import React from 'react';
import { Typography, Button } from '@mui/material';
import { getPhoneNumber, formatPhoneURI, formatPhoneNumber } from '@icims-design-system/i18next';
import { imgUrls, defaultCountryCode, phoneNumberFormat } from 'appConstants';
import { useStyles } from './styles';
import PropTypes from 'prop-types';

const RenderPhoneNumberCell = ({ phoneNumber, t }) => {
  const phoneNumberData = phoneNumber ? getPhoneNumber(phoneNumber) : {};
  const { country, number } = phoneNumberData;
  const countryCode = country ? country.toLowerCase() : country;
  const classes = useStyles();

  if (!countryCode) {
    return (
      <div className={classes.invalidClass}>
        <img
          alt={t('invalid_number', 'Invalid Number')}
          src={`${imgUrls.COUNTRY_FLAGS}/unk.png`}
          className={classes.countryFlag}
        />
        <Typography className={classes.invalidTypo}>{t('invalid', 'Invalid')}</Typography>
      </div>
    );
  }

  return (
    <Button href={formatPhoneURI(phoneNumberData)}>
      <img
        alt={`${countryCode} flag`}
        src={`${imgUrls.COUNTRY_FLAGS}/${countryCode}.png`}
        className={classes.countryFlag}
      />
      {countryCode && (
        <Typography className={classes.phoneNumber}>
          {formatPhoneNumber(
            number,
            countryCode === defaultCountryCode
              ? phoneNumberFormat.NATIONAL
              : phoneNumberFormat.INTERNATIONAL,
          )}
        </Typography>
      )}
    </Button>
  );
};

RenderPhoneNumberCell.propTypes = {
  phoneNumber: PropTypes.string,
  t: PropTypes.func,
};

export default RenderPhoneNumberCell;
